export default __webpack_public_path__ + "static/media/img_mobile_tyre.82499da5.svg";